import React from "react";
import content from "../content/content.json";


const FeaturedInsights = () => {
  const { featuredInsights, shared } = content;

  return (
    <section className="w-full bg-[#FAFAFA] py-20 px-4 md:px-10 lg:px-16">
      <div className="flex items-center justify-between mb-12 flex-wrap gap-6">
        <h2 className="text-4xl md:text-5xl font-extrabold text-[#1C1F2B]">{featuredInsights.heading}</h2>

        <a href="/projects" className="more-insight-btn group relative overflow-hidden border border-[#E4002B] px-8 py-4 font-semibold rounded-none flex items-center gap-2">
          <span className="relative z-10 text-white group-hover:text-[#E4002B] transition-colors duration-300">
            {featuredInsights.moreInsights}
          </span>
          <span className="relative z-10 text-white text-xl group-hover:text-[#E4002B] transition-colors duration-300">
            {shared.arrow}
          </span>
        </a>
      </div>

      <div className="grid md:grid-cols-3 gap-10">
        {featuredInsights.cards.map((item) => (
          <div key={item.id} className="flex flex-col bg-white h-full shadow-sm rounded-md">
            <div className="h-64 w-full overflow-hidden rounded-md">
            <a href={`/projects/${item.id}`} >
              <img
                src={item.image}
                alt={item.title}
                className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
                />
                </a>
            </div>
            <div className="flex flex-col justify-between flex-grow p-4">
              <div>
                <span className="text-[#007681] font-semibold text-sm uppercase mb-2 block">{item.type}</span>
                <a href={`/projects/${item.id}`}>
                  <h3 className="text-2xl font-bold text-[#1C1F2B] mb-4 hover:text-[#0D6EFD]">{item.title}</h3>
                </a>
                <p className="text-gray-600 text-base mb-6 leading-relaxed">{item.description}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default FeaturedInsights;

